import type { IReadonlyStore, Unsubscribe } from "@crialume/sdk";

export interface WritableStore<S> extends IReadonlyStore<S> {
  setState(update: Partial<S> | ((state: S) => Partial<S>)): void;
  /** Visão somente leitura — é o que os módulos recebem. */
  readonly readonly: IReadonlyStore<S>;
}

/** Store mínimo (sem dependência). Imutável: cada set gera um novo objeto. */
export function createStore<S extends object>(initial: S): WritableStore<S> {
  let state = initial;
  const listeners = new Set<(state: S, previous: S) => void>();

  const getState = () => state;
  const subscribe = (listener: (state: S, previous: S) => void): Unsubscribe => {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  };

  return {
    getState,
    subscribe,
    setState(update) {
      const partial = typeof update === "function" ? update(state) : update;
      const previous = state;
      state = { ...state, ...partial };
      for (const listener of [...listeners]) listener(state, previous);
    },
    readonly: { getState, subscribe },
  };
}
